import { Modal, Text, Flex, Button } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { Logger } from 'src/utils/Logger';

type ListItemDeletionModalProps = {
  opened: boolean;
  close: () => void;
  form: UseFormReturnType<FormValuesType>;
  entityType: string;
  index: number;
  clientId: string;
  deleteEntityByTypeAndId: (
    clientId: string,
    entityType: string,
    entityId: string,
  ) => Promise<unknown>;
};

export function ListItemDeletionModal({
  opened,
  close,
  form,
  entityType,
  index,
  clientId,
  deleteEntityByTypeAndId,
}: ListItemDeletionModalProps) {
  const handleDeleteConfirm = async () => {
    const entityArray = form.getValues()[entityType];
    if (Array.isArray(entityArray)) {
      try {
        if (clientId && entityArray[index].id) {
          await deleteEntityByTypeAndId(clientId, entityType, entityArray[index].id.toString());
        } else {
          Logger.warn('Could not delete entity', { clientId, index, entityArray });
        }

        entityArray.splice(index, 1);
        form.setValues({ [entityType]: entityArray });
        form.setDirty({ [entityType]: true });
      } catch (e) {
        notifyAndLogError(
          'Failed to delete item',
          'Something went wrong deleting this item. Please try again and contact support if the issue persists',
          e,
          {
            entityType,
            entity: entityArray[index],
          },
        );
      }
    }

    close();
  };

  return (
    <Modal opened={opened} onClose={close} title="Are you sure?" centered>
      <Text c="gray.10">Once deleted you cannot recover this item.</Text>
      <Flex justify="flex-end" mt="xl">
        <Button onClick={handleDeleteConfirm} type="button" mr="xs">
          Yes
        </Button>
        <Button variant={'default'} onClick={close}>
          No
        </Button>
      </Flex>
    </Modal>
  );
}
